module.exports = __webpack_public_path__ + "static/media/aehspromo1.785cbe97.jpeg";